export default "__VITE_ASSET__CwPC7FCW__"